
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Ebene_1","xmlns":"http://www.w3.org/2000/svg","version":"1.1","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('rect',{attrs:{"fill":"#041b44","width":"32","height":"32","rx":"3.08","ry":"3.08"}}),_c('g',{attrs:{"fill":"#009ee2"}},[_c('path',{attrs:{"d":"M14.55 16.49H7.82c-.1 0-.19.06-.24.14l-4.76 8.69c-.1.19.03.41.24.41h3.97c.1 0 .19-.06.24-.14l2.37-4.33a.27.27 0 01.24-.14h2.43c.1 0 .19-.06.24-.14l2.23-4.07c.1-.19-.03-.41-.24-.41z"}}),_c('path',{attrs:{"d":"M25.81 6.26h-3.97c-.1 0-.19.06-.24.14l-2.33 4.26c-.07.13-.21.22-.37.22h-8.01c-.1 0-.19.06-.24.14l-2.23 4.07c-.1.19.03.41.24.41h7.59c.16 0 .27.17.19.32l-2.67 4.88c-.1.19.03.41.24.41h3.97c.1 0 .19-.06.24-.14l7.83-14.3c.1-.19-.03-.41-.24-.41zM28.94 10.88h-3.97c-.1 0-.19.06-.24.14l-5.3 9.68c-.1.19.03.41.24.41h3.97c.1 0 .19-.06.24-.14l5.3-9.68c.1-.19-.03-.41-.24-.41z"}})])])
          )
        }
      }
    